import React from 'react';
import {Route} from 'react-router';

export const UnauthorizedRoute = (props) => {
    return(<Route exact={props.exact} path={props.path} component={props.component}/>);
};